import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Modal } from 'react-bootstrap'

import closeImg from 'Assets/x-icon-gray.svg'
import successImg from 'Assets/success-challenge.svg'

import style from './style.css'

export default function ChallengeSentModal (props) {
  const title = props.sendSuccess ? 'Thanks for your feedback!' : 'Error'
  const message = props.sendSuccess
    ? 'We appreciate your feedback!'
    : 'There was an error submitting your report.'
  return (
    <Modal show={true} className={classnames(style.modalContainer)}>
      <div className={style.containerModal} tabIndex="0">
        <Modal.Header className={classnames('modal-header', style.headerContainer)}>
          <Modal.Title>
            {title}
            <button
              onClick={props.onClick}
              className={classnames(style.hideModal)}
            >
              <img
                src={closeImg}
                alt="Close message"
              />
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.sendSuccess &&
            <div className={style.containerImage}>
              <img
                className={style.image}
                src={successImg}
                alt="Success"
              />
            </div>
          }
          <p className={style.content}>
            {message}
          </p>
        </Modal.Body>
        <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
          <button
            aria-label="Continue"
            className={classnames('btn-cdl-main')}
            onClick={props.onClick}
          >
              Continue
          </button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

ChallengeSentModal.propTypes = {
  onClick: PropTypes.func.isRequired,
  sendSuccess: PropTypes.bool
}
